import React from 'react';
import { Box } from '@mui/material';

const Logo = ({ size = 40 }) => {
  return (
    <Box
      sx={{
        width: 'auto',
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img 
        src="https://i.ibb.co/GvC7TLh1/D4-B0-AA92-F208-4600-BFFF-DE848187377-E.png"
        alt="WatchPassion Logo" 
        style={{ height: '100%' }} 
      />
    </Box>
  );
};

export default Logo;
